
export function loadData({success, error}) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get('/api/types')
      .then(({body: {data: {items: [staticData]}}}) => staticData)
      .then(success)
      .catch(error);
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/staticData.js